export const createTempId = () => {
  try {
    if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
      return crypto.randomUUID();
    }
  } catch (e) {
    // ignore
  }
  return `tmp_${Date.now()}_${Math.random().toString(16).slice(2)}`;
};

